import script from "./h5Center.vue?vue&type=script&setup=true&lang=js"
export * from "./h5Center.vue?vue&type=script&setup=true&lang=js"

import "./h5Center.vue?vue&type=style&index=0&id=0dbaaac6&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dbaaac6"]])

export default __exports__